<template>
    <div>
		<input type="checkbox" :id="id"
			:readonly="readonly"
			@change="onChange"
			v-model="iValue">
		<label :for="id" :disabled="readonly" ref="label">{{text}}</label>
	</div>
</template>

<script>

import GUID from '../mixins/GUIDMixin';

export default {
	name: 'CCheckbox',
	mixins: [GUID],
	props: {
		value: {
			type: Boolean,
			required: false,
		},
		text: {
			type: String,
			required: false,
		},
		readonly: {
			type: Boolean,
			required: false,
			default: false,
		},
		backgroundColor: {
			type: String,
			required: false,
			default: 'transparent',
		},
		color: {
			type: String,
			required: false,
			default: 'red',
		},
	},
	data() {
		return {
			iValue: this.value,
			id: this.getChkBoxId(),
		};
	},
	watch: {
		value() {
			this.iValue = this.value;
			this.setColor();
		},
		backgroundColor() {
			this.setColor();
		},
		color() {
			this.setColor();
		},
	},
	mounted() {
		this.setColor();
	},
	computed: {

	},
	methods: {
		onChange() {
			this.$emit('input', this.iValue);
			this.$emit('change', this.iValue);
		},
		getChkBoxId() {
			return `chkBx${this.createGuid()}`;
		},
		setColor() {
			this.$refs.label.style.borderColor = this.color;
			this.$refs.label.style.color = this.backgroundColor;
			if (this.iValue) {
				this.$refs.label.style.backgroundColor = this.color;
			} else {
				this.$refs.label.style.backgroundColor = this.backgroundColor;
			}
		},
	},
};
</script>

<style lang="scss" scoped>

	@import "/style/_globals";

	input[type="checkbox"] {
		display:none;
	}
	input[type="checkbox"][readonly] + label {
		pointer-events: none;
	}
	input[type="checkbox"] + label::before {
		width: 33px;
		height: 33px;
		border: 3px solid ;
		border-color: inherit;
		background-color: inherit;
		display: block;
		content: "";
		float: left;
		margin-right: 5px;
		margin-top:3px;
	}
	input[type="checkbox"]:checked+label::before {
		box-shadow: inset 0px 0px 0px 5px;
	}

	input[type="checkbox"]:hover + label::before {
		cursor: pointer;
	}
</style>
